import React from "react";

const OpenInNewWindow = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
			<path
				id="icon-open"
				d="M14.455,5V6.455H18.5L9.568,15.386l1.045,1.045L19.545,7.5v4.045H21V5ZM5,7.909V21H18.091V11.545L16.636,13v6.545H6.455V9.364H13l1.455-1.455Z"
				transform="translate(-5 -5)"
				fill="#fff"
			/>
		</svg>
	);
};

export default OpenInNewWindow;
